import React, {useMemo} from 'react'
import {useWarrantyContext, WARRANTY_STEPS} from '../util/warranty-context'
import {Button, Flex} from '@chakra-ui/react'
import {ACCOUNT_HREF} from '../../../constants'
import {FormattedMessage, useIntl} from 'react-intl'

import {defineMessages} from 'react-intl'
import Link from '../../../components/link'

export const stepTranslations = defineMessages({
    PRODUCT_SELECTION: {
        id: 'warranty_portal.step.name.product_selection',
        defaultMessage: 'Your product'
    },
    PRODUCT_DETAILS: {
        id: 'warranty_portal.step.name.product_details',
        defaultMessage: 'Product details'
    },
    POINT_OF_PURCHASE: {
        id: 'warranty_portal.step.name.point_of_purchase',
        defaultMessage: 'Point of purchase'
    },
    CUSTOMER_DATA: {
        id: 'warranty_portal.step.name.customer_data',
        defaultMessage: 'Customer data'
    }
})

const WarrantyFooter = () => {
    const {isFirstStep, isLastStep, isSubmitting, goToPreviousStep, step, mode} =
        useWarrantyContext()
    const intl = useIntl()

    function getStepKey(mode, step) {
        const steps = WARRANTY_STEPS[mode]
        return Object.keys(steps).find((key) => steps[key] === step)
    }

    const {prevKey, nextKey} = useMemo(() => {
        return {
            prevKey: getStepKey(mode, step - 1),
            nextKey: getStepKey(mode, step + 1)
        }
    }, [mode, step])

    const translatedPrevStep = useMemo(
        () =>
            intl.formatMessage(
                stepTranslations[prevKey] ?? {
                    id: 'warranty_portal.unknown_step',
                    defaultMessage: prevKey ?? 'Unknown'
                }
            ),
        [intl, prevKey]
    )

    const translatedNextStep = useMemo(
        () =>
            intl.formatMessage(
                stepTranslations[nextKey] ?? {
                    id: 'warranty_portal.unknown_step',
                    defaultMessage: nextKey ?? 'Unknown'
                }
            ),
        [intl, nextKey]
    )

    const backToAccount = (
        <Link to={ACCOUNT_HREF}>
            <FormattedMessage
                defaultMessage="Go back to Account"
                id="warranty_portal.back_to_account"
            />
        </Link>
    )

    return (
        <Flex
            flexDirection="column"
            alignItems={{base: 'center', md: 'normal'}}
            gap={{base: 4, md: 6}}
        >
            <Flex
                justifyContent="space-between"
                alignItems="center"
                flexDirection={{base: 'column-reverse', md: 'row'}}
                flexWrap="wrap"
                gap={4}
            >
                {isFirstStep ? (
                    backToAccount
                ) : (
                    <Button
                        type="button"
                        variant="outline"
                        isDisabled={isSubmitting}
                        onClick={() => goToPreviousStep()}
                    >
                        {intl.formatMessage(
                            {
                                defaultMessage: 'Back to {prevStep}',
                                id: 'warranty_portal.go_back'
                            },
                            {
                                prevStep: translatedPrevStep
                            }
                        )}
                    </Button>
                )}

                <Button type="submit" isDisabled={isSubmitting}>
                    {isLastStep
                        ? intl.formatMessage({
                              defaultMessage: 'Submit',
                              id: 'global.submit'
                          })
                        : intl.formatMessage(
                              {
                                  defaultMessage: 'Continue to {nextStep}',
                                  id: 'warranty_portal.continue'
                              },
                              {
                                  nextStep: translatedNextStep
                              }
                          )}
                </Button>
            </Flex>
            {!isFirstStep && backToAccount}
        </Flex>
    )
}

export default WarrantyFooter
